import React from "react";
import CompanySearch from "./CompanySearch.jsx";
import { goToStock } from "../utils/route.js";

// Quick links under the search box (tag -> ticker)
const SAMPLE_TAGS = [
  ["Apple", "AAPL"],
  ["Microsoft", "MSFT"],
  ["NVIDIA", "NVDA"],
  ["Tesla", "TSLA"],
  ["Amazon", "AMZN"],
  ["JPMorgan", "JPM"],
];

export default function LandingHome() {
  return (
    <main className="hero-section">
      <div className="hero-logo">
        <span className="logo-text-highlight">SpedVest</span>
      </div>
      <p className="hero-subtitle">Search any US stock to see its charts, financials and valuation</p>

      <div className="search-box-container">
        <CompanySearch className="hero-search" placeholder="Search a company or ticker, e.g. AAPL" autoFocus />
      </div>

      <div className="analyse-section">
        <span className="analyse-label">Try:</span>
        <div className="tags-container">
          {SAMPLE_TAGS.map(([label, ticker]) => (
            <button key={ticker} className="tag-btn" onClick={() => goToStock(ticker)}>
              {label}
            </button>
          ))}
        </div>
      </div>
    </main>
  );
}
